module.exports = __webpack_public_path__ + "assets/workforce-planning.png?e0ecf8aba758b60a76970a4ace4af5c7";